///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import getAnalyticsGridView from "./getAnalyticsGridViewName";

export const selectedCellClassName = "selected-cell";

export const clearCustomSelection = () => {
  const removeClass = className => {
    while (document.getElementsByClassName(className).length) {
      document.getElementsByClassName(className)[0].classList.remove(className);
    }
  };
  removeClass("selected-row");
  removeClass("highlight-bottom-none");
  removeClass("highlight-bottom");
  removeClass("highlight-top");
  removeClass("highlight-left");
  removeClass("highlight-right");
  removeClass("selection-transparent");
  removeClass("selected-cell");
};

export const clearSelection = () => {
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
};

export const getRange = (startCell, endCell) => {
  return {
    startColumn:
      startCell.colIndex < endCell.colIndex
        ? startCell.colIndex
        : endCell.colIndex,
    startRow:
      startCell.rowIndex < endCell.rowIndex
        ? startCell.rowIndex
        : endCell.rowIndex,
    endColumn:
      startCell.colIndex > endCell.colIndex
        ? startCell.colIndex
        : endCell.colIndex,
    endRow:
      startCell.rowIndex > endCell.rowIndex
        ? startCell.rowIndex
        : endCell.rowIndex
  };
};

function copyToClipboard(range) {
  let copyString = "";
  const gridId = getGridId(
    window.startCell.isLaneMatch,
    window.startCell.analyticsGridView
  );

  for (let r = range.startRow; r <= range.endRow; r++) {
    for (let c = range.startColumn; c <= range.endColumn; c++) {
      const td = document
        .getElementById(gridId)
        .getElementsByTagName("tbody")[0]
        .getElementsByTagName("tr")
        [r].getElementsByTagName("td")[c];
      const th = document
        .getElementById(gridId)
        ?.getElementsByTagName("thead")[0]
        ?.getElementsByTagName("tr")[0]
        ?.getElementsByTagName("th")[c];
      if (td) {
        const input = td.getElementsByTagName("input")[0];
        let value = "";
        if (input && input.getAttribute("type") === "text") {
          value = input.getAttribute("value");
        } else if (input && input.getAttribute("type") === "checkbox") {
          value = input.checked ? "yes" : "no";
        } else {
          value = td.textContent;
        }
        if (value) {
          const unitLeft = th?.getAttribute("data-left-unit");
          const unitRight = th?.getAttribute("data-right-unit");
          if (unitLeft && value.indexOf(unitLeft) === -1) {
            value = unitLeft + value;
          } else if (unitRight && value.indexOf(unitRight) === -1) {
            value = value + unitRight;
          }
        }
        copyString =
          copyString + (c === range.startColumn ? value : "\t" + value);
      }
    }
    if (r !== range.endRow) {
      copyString += "\n";
    }
  }

  const elem = document.createElement("textarea");
  elem.value = copyString;
  document.body.appendChild(elem);
  elem.select();
  document.execCommand("copy");
  document.body.removeChild(elem);
}
const getRow = (rowIndex, isLaneMatch, analyticsGridView) =>
  document
    .getElementById(getGridId(isLaneMatch, analyticsGridView))
    ?.getElementsByTagName("tbody")[0]
    ?.getElementsByTagName("tr")[rowIndex];

const getCell = (row, column, isLaneMatch, analyticsGridView) =>
  getRow(row, isLaneMatch, analyticsGridView)?.getElementsByTagName("td")[
    column
  ];

export const boxHighlight = () => {
  const range = getRange(window.startCell, window.endCell);
  const isLaneMatch = window.startCell.isLaneMatch;
  const analyticsGridView = window.startCell.analyticsGridView;
  for (let c = range.startColumn; c <= range.endColumn; c++) {
    for (let r = range.startRow; r <= range.endRow; r++) {
      const td = getCell(r, c, isLaneMatch, analyticsGridView);
      if (td) {
        td.classList.add(selectedCellClassName);
      }
    }
    if (range.startRow !== 0) {
      const td = getCell(range.startRow - 1, c, isLaneMatch, analyticsGridView);
      td && td.classList.add("highlight-bottom-none");
    }
    const topRowCell = getCell(
      range.startRow,
      c,
      isLaneMatch,
      analyticsGridView
    );
    topRowCell && topRowCell.classList.add("highlight-top");
    const bottomRowCell = getCell(
      range.endRow,
      c,
      isLaneMatch,
      analyticsGridView
    );
    bottomRowCell && bottomRowCell.classList.add("highlight-bottom");
  }

  for (let r = range.startRow; r <= range.endRow; r++) {
    const row = getRow(
      r,
      window.startCell.isLaneMatch,
      window.startCell.analyticsGridView
    );
    row && row.classList.add("selected-row");

    let cell = getCell(r, range.startColumn, isLaneMatch, analyticsGridView);
    cell && cell.classList.add("highlight-left");

    cell = getCell(r, range.startColumn - 1, isLaneMatch, analyticsGridView);
    cell && cell.classList.add("highlight-right");

    cell = getCell(r, range.endColumn, isLaneMatch, analyticsGridView);
    cell && cell.classList.add("highlight-right");
  }
};

export const getGridId = (isLaneMatch, analyticsGridView) => {
  if (isLaneMatch) {
    return "lanes-match-grid";
  } else if (analyticsGridView) {
    return `analytics-grid-${getAnalyticsGridView(analyticsGridView)}`;
  } else return "pricing-grid";
};

export const tableSelection = {
  handleClick: (e, rowIndex, colIndex, isLaneMatch, analyticsGridView) => {
    clearCustomSelection();

    if (!window.startCell || !e.shiftKey) {
      window.startCell = {
        rowIndex,
        colIndex,
        isLaneMatch,
        analyticsGridView
      };
      window.endCell = undefined;
    } else {
      window.endCell = {
        rowIndex,
        colIndex,
        isLaneMatch,
        analyticsGridView
      };
      boxHighlight();
      e.preventDefault();
    }
  },
  handleCopy: () => {
    if (window.startCell && window.endCell) {
      copyToClipboard(getRange(window.startCell, window.endCell));
    }
  },
  handleKeyDown: e => {
    const cAsciiCode = 67;
    if (
      e.ctrlKey &&
      e.keyCode === cAsciiCode &&
      window.startCell &&
      window.endCell
    ) {
      copyToClipboard(getRange(window.startCell, window.endCell));
    }
  },
  onMouseDown: (e, rowIndex, colIndex, isLaneMatch, analyticsGridView) => {
    clearSelection();
    if (!e.shiftKey) {
      clearCustomSelection();
      window.startCell = {
        rowIndex,
        colIndex,
        isLaneMatch: isLaneMatch,
        analyticsGridView: analyticsGridView
      };
    }
  },
  onMouseEnter: (e, rowIndex, colIndex, isLaneMatch, analyticsGridView) => {
    if (e.buttons === 1 || e.buttons === 3) {
      clearCustomSelection();
      if (
        window.startCell &&
        (window.startCell.isLaneMatch === isLaneMatch ||
          window.startCell.analyticsGridView === analyticsGridView)
      ) {
        if (
          window.startCell.rowIndex === rowIndex &&
          window.startCell.colIndex === colIndex
        ) {
          document
            .getElementById(getGridId(isLaneMatch, analyticsGridView))
            .classList.remove("selection-transparent");
        } else {
          document
            .getElementById(getGridId(isLaneMatch, analyticsGridView))
            .classList.add("selection-transparent");
          window.endCell = {
            rowIndex,
            colIndex,
            isLaneMatch,
            analyticsGridView
          };
          boxHighlight();
        }
      }
    }
  },
  onMouseUp: () => {
    if (window.startCell && window.endCell) {
      clearSelection();
    }
  }
};

export default tableSelection;
